import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'cdpBaseUrl',
  initialState: null as string | null,
  reducers: {
    setCdpBaseUrl(state, action) {
      return action.payload || null;
    },
  },
});

export const { setCdpBaseUrl } = slice.actions;

export default slice.reducer;
